var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "elementType": "section",
      "customClass": "ugc-new-confirm-design"
    }
  }, [_vm.showStepsView ? _c('CustomContainer', {
    staticClass: "ugc-new-confirm-design-steps-view-wrapper",
    attrs: {
      "elementType": "div"
    }
  }, [_c('ugc-new-steps-view')], 1) : _vm._e(), _c('CustomContainer', {
    staticClass: "ugc-new-confirm-design-spinner text-center",
    attrs: {
      "elementType": "div"
    }
  }, [_c('base-spinner', {
    ref: "spinner",
    attrs: {
      "set-spinner-default": _vm.showSpinner,
      "size": "60",
      "position": "initial"
    }
  })], 1), _c('CustomContainer', {
    staticClass: "ugc-new-confirm-design-image-wrapper",
    attrs: {
      "elementType": "div"
    }
  }, [_vm.compositeImgKey ? _c('CustomImage', {
    attrs: {
      "src": _vm.imagesPreview[_vm.compositeImgKey].imgSrc
    },
    on: {
      "load": _vm.onPreviewImageLoaded
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }